import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w-full pb-16" }
const _hoisted_3 = { class: "w-full max-w-2xl mx-auto" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "max-w-2xl mx-auto bg-white shadow-2xl rounded-3xl ring-1 ring-gray-200 lg:max-w-none"
}
const _hoisted_6 = {
  key: 0,
  class: "min-w-full py-4 mt-4 text-center text-green-900"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "lg:mx-0" }
const _hoisted_9 = { class: "p-8 sm:px-10" }
const _hoisted_10 = { class: "pr-8 mx-auto mt-8 text-sm divide-y divide-gray-200 lg:col-span-7 lg:mt-0 lg:max-w-md" }
const _hoisted_11 = { class: "flex items-center justify-between py-4" }
const _hoisted_12 = { class: "text-gray-600" }
const _hoisted_13 = { class: "font-medium text-gray-900" }
const _hoisted_14 = { class: "flex items-center justify-between py-4" }
const _hoisted_15 = { class: "text-gray-600" }
const _hoisted_16 = { class: "font-medium text-gray-900" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "flex items-center justify-between py-4"
}
const _hoisted_19 = { class: "font-medium text-clay-700" }
const _hoisted_20 = { class: "mx-auto leading-7 text-center text-gray-600 text-md md:max-w-md" }
const _hoisted_21 = { class: "p-4 mx-auto -mt-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0" }
const _hoisted_22 = { class: "py-10 text-center rounded-2xl bg-gray-50 ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-8" }
const _hoisted_23 = { class: "max-w-xs px-8 mx-auto" }
const _hoisted_24 = { class: "flex items-baseline justify-center mt-6 gap-x-2" }
const _hoisted_25 = { class: "text-5xl font-bold tracking-tight text-gray-900" }
const _hoisted_26 = { class: "px-8 pb-4" }
const _hoisted_27 = {
  role: "list",
  class: "mb-3 ml-3 text-sm leading-6 text-gray-600"
}
const _hoisted_28 = { class: "pr-8 mt-8 text-sm divide-y divide-gray-200 lg:col-span-7 lg:mt-0" }
const _hoisted_29 = { class: "flex items-center justify-between py-4" }
const _hoisted_30 = { class: "font-medium text-gray-900" }
const _hoisted_31 = { class: "flex items-center justify-between py-4" }
const _hoisted_32 = { class: "font-medium text-gray-900" }
const _hoisted_33 = { class: "font-semibold" }
const _hoisted_34 = { class: "flex items-center justify-between py-4" }
const _hoisted_35 = { class: "font-medium text-green-700" }
const _hoisted_36 = { class: "" }
const _hoisted_37 = { class: "flex items-center justify-between py-4" }
const _hoisted_38 = { class: "font-medium text-gray-900" }
const _hoisted_39 = { class: "font-semibold" }
const _hoisted_40 = { class: "max-w-2xl mx-auto" }
const _hoisted_41 = { class: "px-6 py-4 pr-8 rounded-xl bg-gray-50" }
const _hoisted_42 = { class: "" }
const _hoisted_43 = { class: "mt-3 text-clay-800" }
const _hoisted_44 = { class: "block font-semibold" }
const _hoisted_45 = { class: "mt-8 text-sm divide-y divide-gray-200" }
const _hoisted_46 = { class: "flex items-center justify-between pb-4" }
const _hoisted_47 = { class: "font-medium text-gray-900" }
const _hoisted_48 = { class: "flex items-center justify-between py-4" }
const _hoisted_49 = { class: "font-medium text-gray-900" }
const _hoisted_50 = {
  key: 1,
  class: "max-w-4xl px-8 py-12 mx-auto mt-16 mb-32 text-center shadow-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 bg-zinc-50"
}

import {onMounted, ref} from 'vue';
import {client} from '@/shared';
import {
    ChangeMembershipPlan,
    PreviewChangeMembershipPlan,
    PreviewChangeMembershipPlanResponse
} from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChangeProPlan',
  props: {
    currentPlan: {},
    changeablePlanNames: {}
  },
  setup(__props: any) {

const props = __props;

let responseStatus = ref(null);
let allPlans = [
    {
        id: "yearly",
        name: "yearly",
        priceInCents: 14340,
        nameLabel: "StageAgent Yearly",
        perMonth: "$11.95/mo",
        priceLabel: "$11.95 USD",
        priceAnnually: "143.40",
        renewsAfterLabel: "year",
        radioDesc: "Billed $143.40 USD every year",
    }
];

let selectedPlan = ref(null)
let couponCode = ref('');
let planChangePreviewed = ref(false);
let planChanged = ref(false);
let processing = ref(false);

const previewPlanChange = ref(new PreviewChangeMembershipPlanResponse());

onMounted(async () => {
    await onPlanSelected(allPlans[0]);
});

const isFetching = ref(false);
const onPlanSelected = async (plan: any) => {
    selectedPlan.value = plan;
    isFetching.value = true;
    let data = {
        plan: selectedPlan.value.name,
        couponCode: couponCode.value
    };

    await client.post<PreviewChangeMembershipPlanResponse>(new PreviewChangeMembershipPlan(data))
        .then(response => {
            previewPlanChange.value = response;
            planChangePreviewed.value = true;
            responseStatus.value = null;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
        });
    isFetching.value = false;
};

const changePlan = async () => {
    processing.value = true;

    const data = {
        plan: selectedPlan.value.name,
        couponCode: couponCode.value
    };
    await client.post(new ChangeMembershipPlan(data))
        .then(r => {
            planChanged.value = true;
            responseStatus.value = null;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
        });

    processing.value = false;
};

const formattedCurrency = (amountInCents: any) => {
    let price = (amountInCents / 100).toLocaleString('en-US', {style: 'currency', currency: 'USD'});
    return price;
}


return (_ctx: any,_cache: any) => {
  return (!_unref(planChanged))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!_unref(selectedPlan))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[2] || (_cache[2] = [
                  _createElementVNode("a", {
                    href: "/membership",
                    class: "block w-full px-3 py-4 mt-4 mb-4 text-sm font-semibold text-center text-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-clay-600"
                  }, "Go Back ", -1)
                ])))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (isFetching.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Calculating change in plan... "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("dl", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("dt", _hoisted_12, "Regular PRO " + _toDisplayString(_unref(selectedPlan).nameLabel) + " Price", 1),
                                _createElementVNode("dd", _hoisted_13, _toDisplayString(formattedCurrency(previewPlanChange.value.newRecurringAmount)) + "/year", 1)
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("dt", _hoisted_15, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "block w-full px-3 py-2 placeholder-gray-400 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-electric-500 focus:border-electric-500 sm:text-sm",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(couponCode) ? (couponCode).value = $event : couponCode = $event)),
                                    placeholder: "Promotion Code"
                                  }, null, 512), [
                                    [_vModelText, _unref(couponCode)]
                                  ])
                                ]),
                                _createElementVNode("dd", _hoisted_16, [
                                  _createElementVNode("button", {
                                    disabled: _unref(couponCode) === '',
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onPlanSelected(_unref(selectedPlan))), ["prevent"])),
                                    class: "block w-full px-3 py-2 text-sm font-semibold text-center text-white bg-clay-600 rounded-md shadow-sm hover:bg-clay-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-clay-600",
                                    type: "button"
                                  }, " Apply ", 8, _hoisted_17)
                                ])
                              ]),
                              (previewPlanChange.value.discountAmount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _cache[3] || (_cache[3] = _createElementVNode("dt", { class: "text-clay-700" }, " Discount Applied ", -1)),
                                    _createElementVNode("dd", _hoisted_19, _toDisplayString(formattedCurrency(previewPlanChange.value.discountAmount)), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(ErrorSummary, { "response-status": _unref(responseStatus) }, null, 8, ["response-status"]),
                            _createElementVNode("p", _hoisted_20, [
                              _cache[4] || (_cache[4] = _createTextVNode(" If you change to a Yearly PRO subscription, you will be billed the discounted rate of ")),
                              _createElementVNode("strong", null, _toDisplayString(formattedCurrency(previewPlanChange.value.amountBilledToday)), 1),
                              _cache[5] || (_cache[5] = _createTextVNode(". Your subscription will renew at the regular price unless you cancel before your renewal date. "))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-base font-semibold text-gray-600" }, "Billed Today", -1)),
                                _createElementVNode("p", _hoisted_24, [
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(formattedCurrency(previewPlanChange.value.amountBilledToday)), 1)
                                ]),
                                _createVNode(SaButton, {
                                  onClick: _withModifiers(changePlan, ["prevent"]),
                                  loading: _unref(processing),
                                  variant: "primary"
                                }, {
                                  loading: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createTextVNode(" Processing... ")
                                  ])),
                                  default: _withCtx(() => [
                                    _cache[7] || (_cache[7] = _createTextVNode(" Confirm Change "))
                                  ]),
                                  _: 1
                                }, 8, ["loading"]),
                                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mt-6 text-xs leading-5 text-gray-600" }, "Please click CONFIRM CHANGE to proceed.", -1))
                              ]),
                              _cache[10] || (_cache[10] = _createElementVNode("p", { class: "px-8 mt-4 text-xs leading-5 text-gray-600" }, [
                                _createTextVNode("By confirming, you agree to the automatic renewal terms on this page, confirm your agreement to our "),
                                _createElementVNode("a", {
                                  class: "underline",
                                  target: "_blank",
                                  href: "/pages/terms"
                                }, "Terms of Service"),
                                _createTextVNode(" and re-acknowledge our "),
                                _createElementVNode("a", {
                                  target: "_blank",
                                  class: "underline",
                                  href: "/pages/privacy"
                                }, "Privacy Policy"),
                                _createTextVNode(".")
                              ], -1))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex items-center mt-4 text-center gap-x-4" }, [
                            _createElementVNode("h4", { class: "flex-none mb-4 font-semibold leading-6 text-gray-600" }, "Billing details "),
                            _createElementVNode("div", { class: "flex-auto h-px bg-gray-100" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("dl", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _cache[11] || (_cache[11] = _createElementVNode("dt", { class: "text-gray-600" }, "Regular yearly price", -1)),
                                _createElementVNode("dd", _hoisted_30, _toDisplayString(formattedCurrency(previewPlanChange.value.newRecurringAmount)) + "/year", 1)
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _cache[12] || (_cache[12] = _createElementVNode("dt", { class: "text-gray-600" }, "Renews on", -1)),
                                _createElementVNode("dd", _hoisted_32, [
                                  _createElementVNode("span", _hoisted_33, _toDisplayString(previewPlanChange.value.newPaymentDateInPstAsString), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _cache[13] || (_cache[13] = _createElementVNode("dt", { class: "text-gray-600" }, "Credit for unused time", -1)),
                                _createElementVNode("dd", _hoisted_35, [
                                  _createElementVNode("em", _hoisted_36, _toDisplayString(formattedCurrency(previewPlanChange.value.amountCreditedFromCurrentPlan)), 1)
                                ])
                              ]),
                              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "flex items-center justify-between hidden py-4" }, [
                                _createElementVNode("dt", { class: "text-gray-600" }, "Additional discount"),
                                _createElementVNode("dd", { class: "font-medium text-clay-700" }, [
                                  _createElementVNode("em", { class: "" })
                                ])
                              ], -1)),
                              _createElementVNode("div", _hoisted_37, [
                                _cache[14] || (_cache[14] = _createElementVNode("dt", { class: "font-semibold text-gray-600 uppercase" }, "Billed Today", -1)),
                                _createElementVNode("dd", _hoisted_38, [
                                  _createElementVNode("span", _hoisted_39, _toDisplayString(formattedCurrency(previewPlanChange.value.amountBilledToday)), 1)
                                ])
                              ])
                            ]),
                            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "mt-4 text-center" }, [
                              _createElementVNode("a", {
                                href: "/membership",
                                class: "underline hover:no-underline"
                              }, "Back to membership settings")
                            ], -1))
                          ])
                        ])
                      ]))
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "mb-3 text-lg font-semibold" }, "Current Subscription", -1)),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("dl", _hoisted_42, [
              _createElementVNode("div", null, [
                _createElementVNode("dd", _hoisted_43, [
                  _createElementVNode("span", _hoisted_44, "StageAgent PRO (" + _toDisplayString(_ctx.currentPlan.name) + ")", 1),
                  _cache[18] || (_cache[18] = _createElementVNode("span", { class: "block" }, null, -1)),
                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "block" }, [
                    _createElementVNode("em", null, " Your PRO membership gives you full access to expert-written theatre content and professional networking opportunities. ")
                  ], -1))
                ])
              ])
            ]),
            _createElementVNode("dl", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _cache[20] || (_cache[20] = _createElementVNode("dt", { class: "text-gray-600" }, "Billed", -1)),
                _createElementVNode("dd", _hoisted_47, _toDisplayString(_ctx.currentPlan.planPriceInWords), 1)
              ]),
              _createElementVNode("div", _hoisted_48, [
                _cache[21] || (_cache[21] = _createElementVNode("dt", { class: "text-gray-600" }, "Paid through", -1)),
                _createElementVNode("dd", _hoisted_49, _toDisplayString(_ctx.currentPlan.currentPeriodEndFormatted), 1)
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_50, _cache[23] || (_cache[23] = [
        _createStaticVNode("<p class=\"mb-5 text-2xl font-semibold\">Congratulations!</p><p class=\"mb-5 text-xl\">Congratulations you have successfully changed plans!</p><p class=\"mt-10 mb-5\"><a class=\"px-5 py-3 mb-5 text-base font-medium text-white bg-clay-900 border border-transparent rounded-md hover:bg-gray-900\" href=\"/\">Back to StageAgent Home</a></p><p class=\"\"><a href=\"/membership\">Back to Membership</a></p>", 4)
      ])))
}
}

})